import React, { createContext, useContext } from 'react';

interface ProgramsAndIncentivesContextValue {
    showConfirmationModal: boolean;
    onProgramManualSelect: () => void;
}

const defaultContextValue: ProgramsAndIncentivesContextValue = {
    showConfirmationModal: false,
    onProgramManualSelect: /* istanbul ignore next */ () => {}
};

export const ProgramsAndIncentivesContext = createContext<ProgramsAndIncentivesContextValue | undefined>(undefined);

export const useProgramsAndIncentivesContext = () => {
    const context = useContext(ProgramsAndIncentivesContext);
    if (!context) {
        return defaultContextValue;
    }
    return context;
};

interface ProgramsAndIncentivesProviderProps {
    showConfirmationModal: boolean;
    onProgramManualSelect: () => void;
    children: React.ReactNode;
}

export const ProgramsAndIncentivesProvider = ({
    showConfirmationModal,
    onProgramManualSelect,
    children
}: ProgramsAndIncentivesProviderProps) => (
    <ProgramsAndIncentivesContext.Provider value={{ showConfirmationModal, onProgramManualSelect }}>
        {children}
    </ProgramsAndIncentivesContext.Provider>
);
